import { render } from "./ScontiTypeBadge.vue?vue&type=template&id=08226a02"
import script from "./ScontiTypeBadge.vue?vue&type=script&lang=js"
export * from "./ScontiTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__